export default __webpack_public_path__ + "static/media/ic_invisibility.f8e4dd94.svg";